import React from 'react';
import { useTranslation } from 'react-i18next';

import { ApplicationView } from '@shared/enums';
import { isDefaultView } from '@shared/utils/applications';

type Props = {
  view: ApplicationView;
};

export const ApplicationCardItemsTitle = (props: Props) => {
  const { t } = useTranslation();

  const title = isDefaultView(props.view) ? 'needs' : 'letter';

  return <div className="text-black-50 text-xxs mb-2">{t(title)}</div>;
};
